import { useViewportSize } from "@mantine/hooks";
import { showNotification } from "@mantine/notifications";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../services/api";

export default function File(){
  const {fileId} = useParams();

  const [fileData, setFileData] = useState(null);

  React.useEffect(() => {
    if(fileId){
      api.get(`/files-public/data/${fileId}`)
      .then(({data: {file}}) => {
        setFileData(file);
      })
      .catch(err => {
        showNotification({title: "Ops", message: err.message, color: 'red'});
      })
    }
  }, [fileId])

  const { width, height } = useViewportSize();

  return <>
    {fileData && <iframe loading="lazy" width={width} height={height} 
        src={width < 900
            ? `https://docs.google.com/gview?url=${fileData.file}&embedded=true`
            : `${fileData.file}?&amp;download=true&amp;print=&amp;openfile=false#view=fitH`}
    ></iframe>}
  </>;
};
